import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/placeholders/placeholders"
 * Contains 6 texture(s)
 */
export class PlaceholdersAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/placeholders/placeholders';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'slot-load.png',
        'slot-king.png',
        'slot-empty.png',
        'slot-empty-restart.png',
        'slot-empty-no-cards.png',
        'slot-ace.png'
    ] as const;
}
